import { memo } from 'react';

import AirtableIcon from '@/assets/airtable-logo.svg?react';
import APIIcon from '@/assets/custom-code-icon.svg?react';
import ExcelIcon from '@/assets/excel-icon.svg?react';
import DefaultExportIcon from '@/assets/export-icon.svg?react';
import GoogleDriveIcon from '@/assets/google-drive-logo.svg?react';
import GoogleSheetsIcon from '@/assets/google-sheets-logo.svg?react';
import MakeIcon from '@/assets/make-logo.svg?react';
import ManualIcon from '@/assets/manual-icon.svg?react';
import MicrosoftOneDriveIcon from '@/assets/microsoft-one-drive-logo.svg?react';
import N8NIcon from '@/assets/n8n-logo.svg?react';
import PowerAutomateIcon from '@/assets/power-automate-logo.svg?react';
import ZapierIcon from '@/assets/zapier-logo.svg?react';
import { merge } from '@/components';
import { WebhookIcon } from '@/components/icons';
import {
  EXPORT_TO_AIRTABLE_FUNCTION_ID,
  EXPORT_TO_API_FUNCTION_ID,
  EXPORT_TO_GOOGLE_DRIVE_FUNCTION_ID,
  EXPORT_TO_GOOGLE_SHEETS_FUNCTION_ID,
  EXPORT_TO_MAKE_FUNCTION_ID,
  EXPORT_TO_MANUAL_FUNCTION_ID,
  EXPORT_TO_MICROSOFT_EXCEL_FUNCTION_ID,
  EXPORT_TO_MICROSOFT_ONE_DRIVE_FUNCTION_ID,
  EXPORT_TO_N8N_FUNCTION_ID,
  EXPORT_TO_POWER_AUTOMATE_FUNCTION_ID,
  EXPORT_TO_WEBHOOK_FUNCTION_ID,
  EXPORT_TO_ZAPIER_FUNCTION_ID,
} from '@/constants';
import { SVGProps } from '@/utils';

export type ExportIconProps = SVGProps & {
  functionId?: string;
};

const IExportIcon = ({ functionId, className, ...rest }: ExportIconProps) => {
  /* prettier-ignore */
  const styles = [
    'size-4',
  ];

  switch (functionId) {
    case EXPORT_TO_MANUAL_FUNCTION_ID:
      return <ManualIcon className={merge(styles, className)} {...rest} />;
    case EXPORT_TO_WEBHOOK_FUNCTION_ID:
      return <WebhookIcon className={merge(styles, className)} {...rest} />;
    case EXPORT_TO_MICROSOFT_EXCEL_FUNCTION_ID:
      return <ExcelIcon className={merge(styles, className)} {...rest} />;
    case EXPORT_TO_ZAPIER_FUNCTION_ID:
      return <ZapierIcon className={merge(styles, className)} {...rest} />;
    case EXPORT_TO_POWER_AUTOMATE_FUNCTION_ID:
      return <PowerAutomateIcon className={merge(styles, className)} {...rest} />;
    case EXPORT_TO_MAKE_FUNCTION_ID:
      return <MakeIcon className={merge(styles, className)} {...rest} />;
    case EXPORT_TO_N8N_FUNCTION_ID:
      return <N8NIcon className={merge(styles, className)} {...rest} />;
    case EXPORT_TO_AIRTABLE_FUNCTION_ID:
      return <AirtableIcon className={merge(styles, className)} {...rest} />;
    case EXPORT_TO_API_FUNCTION_ID:
      return <APIIcon className={merge(styles, className)} {...rest} />;
    case EXPORT_TO_MICROSOFT_ONE_DRIVE_FUNCTION_ID:
      return <MicrosoftOneDriveIcon className={merge(styles, className)} {...rest} />;
    case EXPORT_TO_GOOGLE_DRIVE_FUNCTION_ID:
      return <GoogleDriveIcon className={merge(styles, className)} {...rest} />;
    case EXPORT_TO_GOOGLE_SHEETS_FUNCTION_ID:
      return <GoogleSheetsIcon className={merge(styles, className)} {...rest} />;
  }

  return <DefaultExportIcon {...rest} />;
};

export const ExportIcon = memo(IExportIcon) as typeof IExportIcon;
